import { HpAnswerMap } from '@avantia/questionset-model';
import { HpSvgIconTypes } from '@avantia/style-guide';
import { MouseEventHandler } from 'react';
import { HpMetaData } from '../../../tools/clientAndServerUtilities';
import { HpEventDetail, HpOnMouseEvent, HpViewportState } from '../../../types';

export enum HpStatus {
  none = 0,
  complete = 2 << 0,
  current = 2 << 1,
  incomplete = 2 << 2,
  error = 2 << 3,
  highestTouched = 2 << 4,
  afterCurrent = 2 << 5,
  unstarted = 2 << 6
}

export interface HpNavigationTabProps {
  isNavigationAllowed?: boolean;
  key: string;
  name: string;
  onClick?: MouseEventHandler<HTMLLIElement>;
  submenu?: HpNavigationTabProps[];
}

export interface HpNavigationTabControlProps {
  activeKey: string;
  eventDetail: HpEventDetail;
  hasError: boolean;
  highestTouchedKey: string;
  id: string;
  isJourneyComplete: boolean;
  items: HpNavigationTabProps[];
  onClick: HpOnMouseEvent;
}

export interface HpNavigationTabMenuControlProps extends HpNavigationTabControlProps {
  topLevelActiveKey: string;
  topLevelHigestTouchedKey: string;
  topLevelItems: HpNavigationTabProps[];
}

export type HpNavigationTabFunction = (props: HpNavigationTabControlProps) => JSX.Element | null;

export type HpHasFlagFunction = (status: HpStatus) => boolean;

export interface HpDetermineStatusProps {
  activeIndex: number;
  hasActive: boolean;
  hasError: boolean;
  highestTouchedIndex: number;
  index: number;
  isJourneyComplete: boolean;
  isNavigationAllowed?: boolean;
}

export interface HpCreateItemProps {
  clickHandler: React.MouseEventHandler<HTMLLIElement> | undefined;
  hasFlag: HpHasFlagFunction;
  index: number;
  item: HpNavigationTabProps;
  menuClose?: MouseEventHandler<HTMLElement>;
  menuType: HpNavigationMenuType;
  type: HpSvgIconTypes | undefined;
}

export interface HpGetPercentCompletedResult {
  activeIndex: number;
  highestTouchedIndex: number;
  percentCompleted: number;
}

export interface HpCreateTabItems {
  activeIndex: number;
  eventDetail: HpEventDetail;
  hasError: boolean;
  highestTouchedIndex: number;
  isJourneyComplete: boolean;
  items: HpNavigationTabProps[];
  menuClose?: MouseEventHandler<HTMLElement>;
  menuType?: HpNavigationMenuType;
  onClick: HpOnMouseEvent | null;
}

export type HpNavigationMenuType = 'menu' | 'submenu' | undefined;

export interface HpGetNavigationTabControlFunctionProps<MetaDataT extends HpMetaData> {
  metaData: MetaDataT | undefined;
  viewport: HpViewportState;
  answers: HpAnswerMap;
  completeJourney: React.MouseEventHandler<HTMLElement>;
}

export type HpGetNavigationTabControlFunction<MetaDataT extends HpMetaData> = (
  props: HpGetNavigationTabControlFunctionProps<MetaDataT>
) => HpNavigationTabFunction;

export interface HpGetPercentCompletedProps {
  activeKey: string;
  highestTouchedKey: string;
  items: HpNavigationTabProps[];
}
